import React from 'react';
import InteractiveTutorialOverlay from './InteractiveTutorialOverlay';
import { useInteractiveTutorial } from '../../utils/InteractiveTutorialContext';

/**
 * Main Interactive Tutorial Component
 * Renders the tutorial overlay when active
 */
const InteractiveTutorial = () => {
  const { isActive } = useInteractiveTutorial();

  if (!isActive) {
    return null;
  }

  return <InteractiveTutorialOverlay />;
};

export default InteractiveTutorial;

